import React, { useState, useEffect } from 'react';
import './InstagramFeed.css';

const InstagramFeed = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Шлях до статичного JSON файлу
    const INSTAGRAM_POSTS_JSON_URL = '/data/instagram-posts.json';
    
    useEffect(() => {
        const fetchInstagramPosts = async () => {
            try {
                setLoading(true);
                
                // Отримуємо дані зі статичного JSON файлу
                const response = await fetch(INSTAGRAM_POSTS_JSON_URL);
                
                if (!response.ok) {
                    throw new Error('Не вдалося завантажити дані Instagram');
                }
                
                const data = await response.json();
                
                if (data && data.posts && Array.isArray(data.posts)) {
                    // Переконуємося, що у нас є точно 10 постів
                    let processedPosts = [...data.posts];
                    // Якщо постів менше 10, дублюємо останні щоб заповнити
                    while (processedPosts.length < 10) {
                        processedPosts.push(
                            processedPosts[processedPosts.length % data.posts.length]
                        );
                    }
                    // Якщо постів більше 10, беремо тільки перші 10
                    if (processedPosts.length > 10) {
                        processedPosts = processedPosts.slice(0, 10);
                    }
                    
                    setPosts(processedPosts);
                } else {
                    throw new Error('Некоректний формат даних');
                }
            } catch (err) {
                console.error('Помилка завантаження постів Instagram:', err);
                setError('Не вдалося завантажити пости Instagram');
            } finally {
                setLoading(false);
            }
        };
        
        fetchInstagramPosts();
    }, []);
    
    // Якщо дані завантажуються
    if (loading) {
        return <div className="instagram-loading">Завантаження останніх постів...</div>;
    }
    
    // Якщо виникла помилка
    if (error || posts.length === 0) {
        return <div className="instagram-error">Не вдалося завантажити Instagram feed</div>;
    }
    
    // Відображення Instagram постів у вигляді сітки як на дизайні
    return (
        <div className="instagram-feed">
            <h2 className="instagram-title">FOLLOW US <a href="https://www.instagram.com/selezium/" target="_blank" rel="noopener noreferrer" className="instagram-tag">#SELEZIUM</a></h2>
            <div className="instagram-grid">
                {posts.map((post, index) => (
                    <a 
                        key={post.id || index} 
                        href={post.permalink} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="instagram-item"
                    >
                        <img 
                            src={post.thumbnail_url}
                            alt="Instagram post"
                            loading="lazy"
                        />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default InstagramFeed; 